import { Text } from '../../../../styles/typography'

const Intro = () => {
  return (
    <div className='intro'>
      <Text>
        For the growing musicians and people who love the content we put out,
        we've made our classes more accessible than ever before.
      </Text>
      <Text className='highlighted'>Introducing, LivDemy Subscriptions.</Text>
    </div>
  )
}

export default Intro
